import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
  'icon',
  'button',
  'root',
  'container',
  'panel',
]);

const settingPanel = definePartsStyle({
  root: {
    boxShadow: 'settingsAccordion',
    shadow: 'none',
    pb: 60,
    maxHeight: 'calc(100vh - 124px)',
    overflowY: 'auto',
  },
  container: {
    borderRadius: 'base',
    mx: 4,
    mb: 4,
    boxShadow: 'settingsAccordion',
  },
  button: {
    paddingInlineEnd: 4,
    paddingInlineStart: 4,
    py: 3,
  },
  panel: {
    paddingInlineEnd: 4,
    paddingInlineStart: 4,
    py: 3,
  },
});

export const Accordion = defineMultiStyleConfig({
  variants: { 'setting-panel': settingPanel },
});
